import React from "react";
import PropTypes from "prop-types";
import Masonry from "react-masonry-css";
import global from "../../scss/dhp.scss";
import cx from "classnames";

let style = Object.assign({}, global);

export const RMasonry = ({ module, children, isTileView }) => {
  const config = {
    documents: {
      responsive: {
        0: 1,
        520: 2,
        767: 3,
        1080: 3,
        1280: 4,
        1400: 5,
        1680: 5,
        1918: 6,
        2219: 7,
        2548: 8,
        2877: 9,
        3206: 10,
        3535: 11,
        3864: 12,
        4193: 13,
        4522: 14,
        4851: 15,
        5180: 16,
        5509: 17,
        5838: 18,
        6167: 19,
        6496: 20,
        6825: 21,
        7154: 22,
        7483: 23,
        7812: 24,
        8141: 25,
        8470: 26,
        8799: 27,
        9128: 28,
        9457: 29,
        9786: 30,
      },
    },
    templates: {
      responsive: {
        0: 1,
        520: 2,
        767: 2,
        1080: 2,
        1280: 3,
        1400: 4,
        1680: 5,
        1918: 5,
        2219: 6,
        2548: 8,
        2877: 9,
        3206: 10,
        3535: 11,
        3864: 12,
        4193: 13,
        4522: 14,
        4851: 15,
        5180: 16,
        5509: 17,
        5838: 18,
        6167: 19,
        6496: 20,
        6825: 21,
        7154: 22,
        7483: 23,
        7812: 24,
        8141: 25,
        8470: 26,
        8799: 27,
        9128: 28,
        9457: 29,
        9786: 30,
      },
    },
    exteranl_templates: {
      responsive: {
        0: 1,
        520: 2,
        767: 2,
        1080: 3,
        1280: 4,
        1400: 4,
        1680: 4,
        1918: 4,
        2219: 4,
        2548: 4,
        2877: 5,
        3206: 5,
        3535: 5,
        3864: 6,
        4193: 6,
        4522: 6,
        4851: 6,
        5180: 6,
        5509: 6,
        5838: 7,
        6167: 7,
        6496: 7,
        6825: 7,
        7154: 7,
        7483: 7,
        7812: 7,
        8141: 7,
        8470: 8,
        8799: 8,
        9128: 8,
        9457: 8,
        9786: 8,
      },
    },
    editor_assets: {
      responsive: {
        9786: 2,
      },
    },
    facebook_images: {
      responsive: {
        9786: 4,
      },
    },
    default: {
      responsive: {
        9786: 3,
      },
    },
  };

  const view = config[module] ?? config.default;

  const breakpointCols = {
    default: view.responsive[9786] || 3,
  };

  Object.keys(view.responsive).forEach((key) => {
    if (key !== "9786") {
      breakpointCols[key] = view.responsive[key];
    }
  });

  return (
    <div className={style["dhp-responsive-masonry"]}>
      <Masonry
        breakpointCols={breakpointCols}
        className={cx("dhp-masonry-grid", style["dhp-masonry"], {
          [style["tile-view"]]: isTileView,
        })}
        columnClassName="dhp-masonry-grid_column"
      >
        {children}
      </Masonry>
    </div>
  );
};

RMasonry.propTypes = {
  module: PropTypes.string.isRequired,
  children: PropTypes.array.isRequired,
  isTileView: PropTypes.bool,
};